import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const bookingAdapter = createEntityAdapter();

const slice = createSlice({
  name: 'ticketsSelected',
  initialState:
    reHydrateStore('ticketsSelected') || bookingAdapter.getInitialState(),
  reducers: {
    setTicketsSelected: (state, { payload }) => ({ ...payload }),
    addTicket: bookingAdapter.upsertOne,
    removeTicket: bookingAdapter.removeOne,
    removeAllTickets: bookingAdapter.removeAll,
    setAllTickets: bookingAdapter.setAll,
    upsertManyTickets: bookingAdapter.upsertMany,
    removeManyTickets: bookingAdapter.removeMany,
  },
});

export const {
  setTicketsSelected,
  addTicket,
  removeTicket,
  removeAllTickets,
  setAllTickets,
  upsertManyTickets,
  removeManyTickets,
} = slice.actions;

export const simpleSelectors = bookingAdapter.getSelectors();

export default slice.reducer;
